import { z } from 'zod';

// Dashboard CDC: 3 widget pending (URGENTI / MANCANTI / GRAMMI NECESSARI).
// Riferimento formule: docs/drive-review/real-files-formulas-2026-05-14.md
// Riferimento mapping: docs/workshop-andrei/product-packaging-mapping.json (290 entries).

export const dashboardPackagingBucketSchema = z.enum(['BARATTOLI', 'SFUSI', 'FUMI', 'OLI']);
export type DashboardPackagingBucket = z.infer<typeof dashboardPackagingBucketSchema>;

export const dashboardWidgetQuerySchema = z.object({
  periodId: z.string().uuid().optional(),
});
export type DashboardWidgetQuery = z.infer<typeof dashboardWidgetQuerySchema>;

// =========================================================
// URGENTI: deficit pezzi per coprire ordini MSS + MSF aperti
// Formula Drive: URGENTI = -(stock - (openMss + openMsf)) se negativo
// =========================================================

export const urgentiItemSchema = z.object({
  productId: z.string().uuid(),
  productCode: z.string(),
  productName: z.string(),
  bucket: dashboardPackagingBucketSchema.nullable(),
  grammatura: z.number().int(),
  stockPezzi: z.number().int(),
  openOrdersMssPezzi: z.number().int(),
  openOrdersMsfPezzi: z.number().int(),
  deficitPezzi: z.number().int(),
});
export type UrgentiItem = z.infer<typeof urgentiItemSchema>;

export const urgentiResponseSchema = z.object({
  periodId: z.string().uuid(),
  periodLabel: z.string(),
  items: z.array(urgentiItemSchema),
});
export type UrgentiResponse = z.infer<typeof urgentiResponseSchema>;

// =========================================================
// MANCANTI: pezzi residui da produrre rispetto al piano mensile
// Formula Drive: REMAINING_PRODUCTION = MEMORY!B + NEW_LIST_1 + NEW_LIST_2 - producedThisMonth
// MVP degenerato (NEW_LIST_1/2 vuoti, no ProductionTarget): MEMORY!B - producedThisMonth
// =========================================================

export const mancantiItemSchema = z.object({
  productId: z.string().uuid(),
  productCode: z.string(),
  productName: z.string(),
  bucket: dashboardPackagingBucketSchema.nullable(),
  grammatura: z.number().int(),
  baselinePezzi: z.number().int(), // MEMORY!B = pezzi inventario chiusura mese precedente
  producedPezzi: z.number().int(), // pezzi inventario chiusura mese corrente
  mancantiPezzi: z.number().int(),
});
export type MancantiItem = z.infer<typeof mancantiItemSchema>;

export const mancantiResponseSchema = z.object({
  periodId: z.string().uuid(),
  periodLabel: z.string(),
  previousPeriodId: z.string().uuid().nullable(),
  previousPeriodLabel: z.string().nullable(),
  items: z.array(mancantiItemSchema),
  degenerated: z.boolean(), // true se formula degenerata (no ProductionTarget)
});
export type MancantiResponse = z.infer<typeof mancantiResponseSchema>;

// =========================================================
// GRAMMI NECESSARI: grammi grezzo per produrre i pezzi MANCANTI
// Formula Drive: TOTAL_WEIGHT(REMAINING_PRODUCTION) = SUM(mancanti_<N>g * tara_reale_<N>g)
// Tara reale: docs/drive-review/real-files-formulas-2026-05-14.md Q5
// =========================================================

export const grammoNecessarioBreakdownSchema = z.object({
  grammatura: z.number().int(),
  mancantiPezzi: z.number().int(),
  taraGramsPerPiece: z.number(),
  grammiGrezzo: z.number(),
});
export type GrammoNecessarioBreakdown = z.infer<typeof grammoNecessarioBreakdownSchema>;

export const grammiNecessariItemSchema = z.object({
  productId: z.string().uuid(),
  productCode: z.string(),
  productName: z.string(),
  totalGrammiGrezzo: z.number(),
  breakdown: z.array(grammoNecessarioBreakdownSchema),
});
export type GrammiNecessariItem = z.infer<typeof grammiNecessariItemSchema>;

export const grammiNecessariResponseSchema = z.object({
  periodId: z.string().uuid(),
  periodLabel: z.string(),
  items: z.array(grammiNecessariItemSchema),
  degenerated: z.boolean(),
});
export type GrammiNecessariResponse = z.infer<typeof grammiNecessariResponseSchema>;
